export default {
  environment: {
    api_url: "https://miib.levantandoacristo.cl",
    ws_url: "https://miib.levantandoacristo.cl:3003",
    frontend_url: "https://cultos.levantandoacristo.local:8080",
    api_site: "wp_8_user_level",
    googleMapsApiKey: "AIzaSyB7NppfedHvDL2veGkme_Q3R8rQQU1cVok",
  },
};
